import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import "./providers/localization";
import store from "./store/store";
import { Provider } from "react-redux";

import App from "./App";
import { Spinner } from "providers/spinner";
import { ProvideAuth } from "api/hooks/useAuth";
import { Welcome } from "providers/welcomeLoader";
import { Worker } from "@react-pdf-viewer/core";
import { Portal } from "@chakra-ui/portal";
import { DefaultImageProvider } from "providers/default-image-provider";
import { NotificationDialogProvider } from "providers/notification-dialog-provider";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter basename="/">
    <Provider store={store}>
      <Spinner />
      <Welcome />
      <ProvideAuth>
        <DefaultImageProvider>
          <NotificationDialogProvider>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
              <Portal>
                <App />
              </Portal>
            </Worker>
          </NotificationDialogProvider>
        </DefaultImageProvider>
      </ProvideAuth>
    </Provider>
  </BrowserRouter>
);
